import { createSlice } from '@reduxjs/toolkit'
import dot from 'dot-object'
import * as types from './types'

const initialState = {
  data: {},
  default: {},
  english: {},
  isLoading: false,
  isLoaded: false,
  persistedDraft: {},
  // Translations type
  type: null,
  id: null,
}

// Optimist-coupled duck: operations.js wraps UPDATE with redux-optimist
// BEGIN/COMMIT/REVERT meta at the store level. This reducer stays optimist-
// agnostic and pure (safe for optimist replay). Action strings preserved by
// keying extraReducers on the imported ./types constants.
// ponytail: dropped the dead `types.SWITCH_KNOWLEDGE_BASE` handler — that
// constant is not exported by ./types, so it was `reducers[undefined]` and
// never fired. Behavior-identical.
const translations = createSlice({
  name: 'translations',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(types.FETCH_TRANSLATIONS_REQUEST, (draftState, action) => {
        return {
          ...initialState,
          type: action.translationType,
          id: action.id,
          isLoading: true,
          isLoaded: false,
        }
      })
      .addCase(types.FETCH_TRANSLATIONS_SUCCESS, (draftState, { data }) => {
        draftState.data = data.user
        draftState.default = data.default
        draftState.english = data.english
        draftState.isLoading = false
        draftState.isLoaded = true
      })
      .addCase(types.FETCH_TRANSLATIONS_FAILURE, (draftState, { err }) => {
        draftState.error = err
        draftState.isLoading = false
        draftState.isLoaded = true
      })
      .addCase(types.UPDATE_TRANSLATIONS_STARTED, draftState => {
        draftState.isLoading = true
      })
      .addCase(types.UPDATE_TRANSLATIONS_SUCCESS, (draftState, { payload }) => {
        draftState.data = payload.data.user
        draftState.isLoading = false
      })
      .addCase(types.UPDATE_TRANSLATIONS_FAILED, (draftState, { payload }) => {
        draftState.error = payload.error
        draftState.isLoading = false
      })
      .addCase(types.RESET_TRANSLATIONS_REQUEST, draftState => {
        draftState.isLoading = true
      })
      .addCase(types.RESET_TRANSLATIONS_SUCCESS, (draftState, { data }) => {
        draftState.data = data.user
        draftState.isLoaded = false
        draftState.isLoading = false
      })
      .addCase(types.RESET_TRANSLATIONS_FAILURE, (draftState, { err }) => {
        draftState.error = err
        draftState.isLoading = false
      })
      .addCase(types.DELETE_TRANSLATION_REQUEST, (draftState, { keyPath }) => {
        dot.delete(keyPath, draftState.data)
        draftState.isLoading = true
      })
      .addCase(types.DELETE_TRANSLATION_SUCCESS, (draftState, { data }) => {
        draftState.data = data.user
        draftState.isLoading = false
      })
      .addCase(types.DELETE_TRANSLATION_FAILURE, (draftState, { err }) => {
        draftState.error = err
      })
      .addCase(
        types.UPDATE_TRANSLATION_PERSISTED_DRAFT,
        (draftState, { payload: { draft } = {} } = {}) => {
          // TODO (jscheel): Look into storing in localstorage or on server as a draft
          draftState.persistedDraft = draft
        }
      )
  },
})

export default translations.reducer
